const baseBlockquoteData = { indentation: 0 };
const BlockquoteData = {
  fromJSON(object) {
    const message = { ...baseBlockquoteData };
    message.indentation = object.indentation !== void 0 && object.indentation !== null ? Number(object.indentation) : 0;
    return message;
  },
  toJSON(message) {
    const obj = {};
    message.indentation !== void 0 && (obj.indentation = Math.round(message.indentation));
    return obj;
  }
};
export {
  BlockquoteData
};
//# sourceMappingURL=node_blockquote.js.map
